import React, { useState,useEffect } from "react";
import {useGetCommoditySpecificSellerListQuery,} from "./ProcurementApiSlice";
import {  Table } from "react-bootstrap";

const CommoditySpecificSeller = ({CommodityName,organizationVal}) => {
  const {data: SellerInterested,isLoading,} = useGetCommoditySpecificSellerListQuery(CommodityName);
  const[sellereInterestedList,setSellerInterested]=useState([])
  useEffect(()=>{
    if(SellerInterested){
        setSellerInterested(SellerInterested?.data)
    }
  },[SellerInterested])
  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center ">
        <div className="spinner-border mb-5 mt-3" role="status"></div>
        <span className="mx-2 m-0 mb-4">Please Wait...</span>
      </div>
    );
  }
 

  return (
    <div className="mt-2">
    <h3 className="text-center font-weight-bold mb-2">List of Sellers Trading in this Commodity</h3>
    
    <Table striped hover responsive className="mt-3">
      <thead className="table-primary"> {/* Light background for the header */}
        <tr>
          <th className="fs-6">Name</th>
          <th className="fs-6">Phone Number</th>
          <th className="fs-6">Email</th>
          <th className="fs-6">Address</th>
          <th className="fs-6">Quantity</th>
          <th className="fs-6">Price</th>
        </tr>
      </thead>
      <tbody>
        {sellereInterestedList?.map((data, index) => {
          return (
            <tr key={index}>
              <td>{data.user.user_name}</td>
              <td>{data.user.user_mobile.slice(0, 5) + "*****"}</td>
              <td>{data.user.email}</td>
              <td>{data.user.address}</td>
              <td>{data.quantity}&nbsp;{data.unit_measurement}</td>
              <td>Rs. {data.price}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  </div>
  );
};

export default CommoditySpecificSeller;
